import { Text } from "components/text";

/** Inline label/value pair for the chart panel footer. */
export const AmazonSalesFooterRow = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => (
  <span>
    {label}{" "}
    <Text
      as="span"
      variant="bodyStrong"
      numeric="tabular"
      className="normal-case"
    >
      {value}
    </Text>
  </span>
);
